import { styled } from '@mui/system';
import SchoolIcon from '@mui/icons-material/School';


const Container = styled('section')({
    display: 'flex',
    flexDirection: 'column',
})

const InfoContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '30px'
})

const Subtitle5 = styled('h5')({
    fontSize: '12px',
    fontWeight: '500',
    color: 'var(--color-light)',
})

const Title = styled('h1')({
    fontSize: '30px',
    color: 'var(--color-primary)'
})

const Wrapper = styled('section')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems : 'center'
})

const Line = styled('div')({
    display: 'flex',
    padding: '20px',
    flexWrap: 'wrap',
    width: '70vw',
    justifyContent: 'center',
})

const Left = styled('div')({
    flex: 3,
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center'
})

const Center = styled('div')({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
})

const Right = styled('div')({
    flex: 3,
    display: 'flex',
    alignItems: 'center'
})

const Sep = styled('span')({
    border: '1px solid var(--color-white)',
    width: '70px',
    transform: 'rotate(90deg)',
})

const YearContainer = styled('p')({
    fontSize: '24px',
    color: 'var(--color-primary)',
    '@media (max-width: 480px)' : {
        fontSize: '18px',
      }
})

const DegreeContainer = styled('p')({
    fontSize: '18px',
    color: 'var(--color-white)',
    '@media (max-width: 480px)' : {
        fontSize: '14px',
      }
})

function Education() {
    return (
        <Container id='education'>
            <InfoContainer>
                <Subtitle5>My academic background</Subtitle5>
                <Title>Education</Title>
            </InfoContainer>
            <Wrapper>
                <Line>
                    <Left>
                        <YearContainer>2023 - 2024</YearContainer>
                    </Left>
                    <Center>
                        <SchoolIcon style={{ border: '1px solid var(--color-white)', borderRadius: '50%', padding: '5px' }} />
                    </Center>
                    <Right>
                        <DegreeContainer>M2 Machine Learning for Data Science</DegreeContainer>
                    </Right>
                </Line>
                <Line>
                    <Sep />
                </Line>
                <Line>
                    <Left>
                        <YearContainer>2020 - 2021</YearContainer>
                    </Left>
                    <Center>
                        <SchoolIcon style={{ border: '1px solid var(--color-white)', borderRadius: '50%', padding: '5px' }} />
                    </Center>
                    <Right>
                        <DegreeContainer>Master's Degree in Scientific Research</DegreeContainer>
                    </Right>
                </Line>
                <Line>
                    <Sep />
                </Line>
                <Line>
                    <Left>
                        <YearContainer>2016 - 2021</YearContainer>
                    </Left>
                    <Center>
                        <SchoolIcon style={{ border: '1px solid var(--color-white)', borderRadius: '50%', padding: '5px' }} />
                    </Center>
                    <Right>
                        <DegreeContainer>Computer science engineer, option Computer systems and software</DegreeContainer>
                    </Right>
                </Line>
                <Line>
                    <Sep />
                </Line>
                <Line>
                    <Left>
                        <YearContainer>2013 - 2016</YearContainer>
                    </Left>
                    <Center>
                        <SchoolIcon style={{ border: '1px solid var(--color-white)', borderRadius: '50%', padding: '5px' }} />
                    </Center>
                    <Right>
                        <DegreeContainer>Bachelor's degree in Mathematics</DegreeContainer>
                    </Right>
                </Line>
            </Wrapper>
        </Container>
    )
}
export default Education